var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75523628,0.113223035 L0.147613628,5.05221166 C0.0533159234,5.1426145 -9.1038288e-14,5.26758761 -9.1038288e-14,5.39821965 C-9.1038288e-14,5.52885169 0.0533159234,5.65382481 0.147613628,5.74422764 L5.75523628,10.680968 C5.84511388,10.7607421 5.96350048,10.8006577 6.0833323,10.7915898 C6.20316413,10.7825219 6.31419605,10.7252458 6.39104563,10.6328551 L7.09115536,9.80099707 C7.25387108,9.60799364 7.23165163,9.32014169 7.04124388,9.15439605 L2.790674,5.48297924 C2.7658567,5.4616241 2.75158281,5.4305105 2.75158281,5.39777 C2.75158281,5.3650295 2.7658567,5.33391589 2.790674,5.31256075 L7.03989492,1.63979499 C7.13191266,1.55986701 7.18837014,1.44662852 7.19682382,1.32503789 C7.20760788,1.20407916 7.16900827,1.08390138 7.0898064,0.99184501 L6.39104563,0.161335907 C6.31433241,0.0684137838 6.20316435,0.0106388521 6.08303332,0.00125943615 C5.96305149,-0.00783652222 5.84458293,0.0326280457 5.75523628,0.113223035 Z",
    id: "Path",
    fill: "#666666",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.b0d259e82109c54c6cd1db839827ef40.svg";
export { ForwardRef as ReactComponent };